import { render, staticRenderFns } from "./nssf-report.vue?vue&type=template&id=16bff23f"
import script from "./nssf-report.vue?vue&type=script&lang=js"
export * from "./nssf-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports